import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, formValueSelector} from 'redux-form';

import classNames from 'classnames';

import Label from 'components/Label';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {buildRoomSelectizeOption} from 'components/Fields/SearchRoomField';
import {buildRoomTypeSelectizeOption} from 'components/Fields/SelectRoomTypeField';
import {SearchRoomField} from 'components/Fields';

import {MODALS} from 'ducks/allocations';
import {
  fetchArchivedRoomOptions,
  fetchRoomTypes,
  undoArchiveRoom
} from 'ducks/rooms';
import {selectModal} from 'ducks/modals';

import {headOption} from 'utils/common';
import {required} from 'utils/validators';
import {SelectRoomTypeField} from 'components/Fields';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {room} = values;
  const {locationRef} = props;
  const roomId = _.get(room, 'object.id');

  dispatch(
    undoArchiveRoom(
      {
        roomId,
        locationRef
      },
      props.getExtraActions()
    )
  );
};

class UndoArchiveRoomForm extends React.Component<any> {
  componentDidMount() {
    const {locationRef} = this.props;

    const fetchRoomTypesExtraActions = this.props.storeDataExtraActions(
      data => ({
        roomTypes: data
      })
    );

    this.props.fetchRoomTypes({locationRef}, fetchRoomTypesExtraActions);
  }

  componentDidUpdate(oldProps) {
    if (
      _.get(oldProps.selectedRoomType, 'label') !==
      _.get(this.props.selectedRoomType, 'label')
    ) {
      this.fetchArchivedRoomOptions(this.props.selectedRoomType);
    }
  }

  fetchArchivedRoomOptions = roomType => {
    if (_.isNil(roomType)) return;

    const {locationRef} = this.props;
    const extraActions = this.props.storeDataExtraActions(data => ({
      roomOptions: data
    }));

    this.props.fetchArchivedRoomOptions(
      {
        locationRef,
        roomType: roomType.value
      },
      extraActions
    );
  };

  onRoomTypeChange = () => {
    this.props.change('room', null);
  };

  render() {
    const {className, handleSubmit, error, roomTypes, roomOptions} = this.props;
    return (
      <form
        onSubmit={handleSubmit}
        className={classNames(className, 'UndoArchiveRoomForm')}>
        {error && <ErrorBlock>{error}</ErrorBlock>}

        <FormField>
          <Label>Room type</Label>
          <SelectRoomTypeField
            groupedRoomTypes={roomTypes}
            onChange={this.onRoomTypeChange}
            validate={[required]}
          />
        </FormField>

        <FormField>
          <Label>Room</Label>
          <SearchRoomField rooms={roomOptions} validators={[required]} />
        </FormField>
      </form>
    );
  }
}

const formSelector = formValueSelector('undoArchiveRoom');

const mapStateToProps = state => {
  const modal = selectModal(state, MODALS.UNDO_ARCHIVE_ROOM);

  const groupedRoomTypes = _.get(modal, 'data.roomTypes', []);
  const roomTypes = _.flatten(
    groupedRoomTypes.map(roomTypeGroup => roomTypeGroup.roomTypes)
  );

  const defaultRoomType = headOption(roomTypes, buildRoomTypeSelectizeOption);
  const roomOptions = _.get(modal, 'data.roomOptions', []);
  const selectedRoomType = formSelector(state, 'roomType');

  return {
    initialValues: {
      roomType: selectedRoomType || defaultRoomType,
      room: headOption(roomOptions, buildRoomSelectizeOption)
    },
    roomTypes: groupedRoomTypes,
    selectedRoomType: selectedRoomType,
    roomOptions
  };
};

const mapDispatchToProps = {
  fetchArchivedRoomOptions,
  fetchRoomTypes,
  undoArchiveRoom
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'undoArchiveRoom',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(UndoArchiveRoomForm)
) as React.ComponentType<any>;
